/**
 * endorsement-tag.ts — an endorsement tag as the student's screens say it: its
 * name in the student's language, and its emoji. The gameplay view's teammate
 * cards, the portfolio's endorsements and the dev tools' adjusters each wrote
 * the name's lookup by hand, four times; written once, a tag the locales do not
 * name reads as its id on every one of them.
 */

import type { TFunction } from 'i18next';

/** Emoji reactions mapped to endorsement tag ids. */
const TAG_EMOJI: Record<string, string> = {
  leader: '👑',
  communication: '💬',
  strategic: '🧠',
  funny: '😄',
  kind: '🤝',
};

/** An endorsement tag's name and emoji: a tag the locales do not name reads as its id, and one the table has no emoji for under a star. */
export function endorsementTag(t: TFunction, id: string): { name: string; emoji: string } {
  return { name: t(`endorsementTags.${id}.name`, { defaultValue: id }), emoji: TAG_EMOJI[id] ?? '⭐' };
}
